<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				饲养计划详情
			</div>
		</div>
		<div class="con">
			<div class="top">
				<div class="left">
					<div class="userinfo">
						<div class="title">
							<div class="tittext">基本信息</div>
							<div class="refen" @click="refresh">
								<i class="el-icon-refresh-left"></i>
							</div>
						</div>
						<div class="usercon" v-if="breedplanDl">
							<div class="useritem"><span class="usertext">顾客</span>：<span
									class="userdesc">{{breedplanDl.user_info.user_name}}</span></div>
							<div class="useritem"><span class="usertext">手机</span>：<span
									class="userdesc">{{breedplanDl.user_info.user_mobile}}</span></div>
							<div class="useritem"><span class="usertext">更新时间</span>：<span
									class="userdesc">{{$public.FTime(breedplanDl.update_address_time,'YYYY-MM-DD')}}</span>
							</div>
							<div class="useritem"><span class="usertext">收货人</span>：<span
									class="userdesc">{{getAdress(breedplanDl.next_plan.address).name}}</span>
							</div>
							<div class="useritem"><span class="usertext">联系电话</span>：<span
									class="userdesc">{{getAdress(breedplanDl.next_plan.address).phone}}</span>
							</div>
							<div class="useritem"><span class="usertext">收货地址</span>：<span
									class="userdesc">{{getAdress(breedplanDl.next_plan.address).province}}
									{{getAdress(breedplanDl.next_plan.address).city}}{{getAdress(breedplanDl.next_plan.address).district}}
									{{getAdress(breedplanDl.next_plan.address).address}}
									</span>
							</div>
							<!-- <div class="useritem"><span class="usertext">地址说明</span>：<span class="userdesc">顾客</span>
							</div> -->
						</div>
					</div>
					<div class="userinfo planinfo">
						<div class="title">
							<div class="tittext">计划套餐</div>
							<div class="refen" @click="refresh">
								<i class="el-icon-refresh-left"></i>
							</div>
						</div>
						<div class="usercon" v-if="breedplanDl">
							<div class="useritem"><span class="usertext">名称</span>：<span
									class="userdesc">{{breedplanDl.gift_bag_info.title}}</span></div>
							<div class="useritem"><span class="usertext">计划</span>：<span
									class="userdesc">{{breedplanDl.gift_bag_info.gift_bag_plan.name}}</span></div>
							<div class="useritem"><span class="usertext">商品</span>：<span
									class="userdesc">{{breedplanDl.next_plan.goods_list.length}}</span></div>
							<div class="useritem"><span class="usertext">已执行次数</span>：<span
									class="userdesc">{{breedplanDl.plan_list.length - breedplanDl.surplus_count}}</span>
							</div>
							<div class="useritem"><span class="usertext">未执行次数</span>：<span
									class="userdesc">{{breedplanDl.surplus_count}}</span>
							</div>
							<div class="useritem"><span class="usertext">下次执行日期</span>：<span
									class="userdesc">{{$public.FTime(breedplanDl.next_shipments_time,'YYYY-MM-DD')}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="title">
						<div class="tittext">套餐信息</div>
						<div class="refen">

							<!-- <i class="el-icon-refresh-left"></i> -->
						</div>
					</div>
					<el-table :data="currentGoods" style="width: 100%" height="200">
						<el-table-column prop="date" label="类型" width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.goods_type==0">商品</span>
								<span v-else>洗美卡</span>
							</template>
						</el-table-column>
						<el-table-column prop="goods_name" label="名称">
						</el-table-column>
						<el-table-column prop="sku_name" label="规格">
						</el-table-column>
						<el-table-column prop="count" label="数量" width="80">
						</el-table-column>
						<el-table-column prop="address" label="多次配送" width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.is_many_times_execute==0">否</span>
								<span v-else>是</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="bottom" v-if="breedplanDl">
				<div class="lf">
					<div class="plandl">
						<div><span class="plantext">当前执行计划：</span><span
								class="plandesc">第{{breedplanDl.next_plan.plan_num}}次</span></div>
						<div><span class="plantext">应录入数量：</span><span class="plandesc">{{totalcount}}</span></div>
						<div><span class="plantext">已录入数量：</span><span class="plandesc">{{hadcount}}</span></div>
					</div>
					<div class="plancode">
						<span>录入条码</span>
						<el-input size='mini' style="width: 200px;margin-left: 10px;" v-model="customcode"
							placeholder="请输入内容" @change="search"></el-input>
					</div>
					<div>
						<el-table ref='table' :data="breedplanDl.next_plan.goods_list" style="width: 100%"
							default-expand-all row-class-name="row-expand-cove">
							<el-table-column prop="date" label="类型" width="100">
								<template slot-scope="scope">
									<span v-if="scope.row.goods_type==0">商品</span>
									<span v-else>洗美卡</span>
								</template>
							</el-table-column>
							<el-table-column prop="goods_name" label="名称">
							</el-table-column>
							<el-table-column prop="sku_value" label="规格">
							</el-table-column>
							<el-table-column prop="count" label="数量" width="80">
							</el-table-column>
							<el-table-column prop="count" label="录入数量" width="80">
								<template slot-scope="scope">
									<span>{{scope.row.order_item_goods_list.length}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="address" label="操作" width="80">
								<template slot-scope="scope">
									<el-button type="text" @click='toogleExpand(scope.row)'>查看条码</el-button>
								</template>
							</el-table-column>

							<el-table-column type="expand" width="1">
								<template slot-scope="props">
									<div class="goodscustom">
										<div style="margin-top: 10px;" v-if="props.row.order_item_goods_list.length>0">
											<span v-for="(goodscustom,subindex) in props.row.order_item_goods_list"
												:key='subindex'>
												<el-tag :closable='goodscustom.firstcode?true:false'
													@close="handleClose(goodscustom)">
													{{goodscustom.custom_code}}
												</el-tag>
											</span>
										</div>
										<div style="margin: 10px;color: #000;" v-else>
											暂无条码数据
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="chuku" style="text-align: center;margin-top: 20px;">
						<el-button size='mini' @click='addcodes()'>提交出库</el-button>
						<el-button size='mini' @click='goback()'>返回</el-button>
					</div>
				</div>
				<div class="rg">
					<el-collapse>
						<el-collapse-item v-for="(item,index) in breedplanDl.plan_list" :key='index'>
							<template slot="title">

								<div style="width: 80%;display: flex;justify-content: space-between;">
									<span>第{{item.plan_num}}次计划</span>
									<span>状态：
										<span v-if="item.plan_status==1"></span>
									</span>
									<span>执行日期：{{$public.FTime(item.real_delivery_time,'YYYY-MM-DD')}}</span>
									<span>物流单号：{{item.ship_no}}</span>
									<span style="color: #FF4400;" @click="setship">{{item.ship_no?'修改单号':'录入单号'}}</span>
								</div>
							</template>

							<div>
								<el-table ref='table' :data="item.goods_list" style="width: 100%"
									default-expand-all row-class-name="row-expand-cove">
									<el-table-column prop="date" label="类型" width="100">
										<template slot-scope="scope">
											<span v-if="scope.row.goods_type==0">商品</span>
											<span v-else>洗美卡</span>
										</template>
									</el-table-column>
									<el-table-column prop="goods_name" label="名称">
									</el-table-column>
									<el-table-column prop="sku_value" label="规格">
									</el-table-column>
									<el-table-column prop="count" label="数量" width="80">
									</el-table-column>


									<el-table-column type="expand" width="1">
										<template slot-scope="props">
											<div class="goodscustom">
												<div style="margin-top: 10px;"
													v-if="props.row.order_item_goods_list.length>0">
													<span
														v-for="(goodscustom,subindex) in props.row.order_item_goods_list"
														:key='subindex'>
														<el-tag :closable='goodscustom.firstcode?true:false'
															@close="handleClose(goodscustom)">
															{{goodscustom.custom_code}}
														</el-tag>
													</span>
												</div>
												<div style="margin: 10px;color: #000;" v-else>
													暂无条码数据
												</div>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>

						</el-collapse-item>

					</el-collapse>

				</div>
			</div>
		</div>
		<el-dialog title="物流信息" :visible.sync="dialogVisible" width="30%">
			<el-form ref="form" label-width="80px">
				<el-form-item label="物流单号">
					<el-input style="width: 200px;" size='mini' v-model="shipParams.ship_no"></el-input>
				</el-form-item>
				<el-form-item label="物流名称">
					<el-input style="width: 200px;" size='mini' v-model="shipParams.ship_name"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size='mini' @click="submitShip">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getbreedplanDl,
		getPetGiftDl,
		addPlanGoodsCodes,
		setPlanShip
	} from '../../../api/program.js'
	import {
		getGoodsCustomCodeInfo,
	} from "@/api/stockApi.js";
	export default {
		data() {
			return {
				breedplanDl: '',
				currentGoods: [],
				customcode: '',
				plancodeParams: {
					id: '',
					plan_no: '',
					codes: [],
				},
				dialogVisible: false,
				shipParams: {
					id: '',
					plan_no: '',
					ship_no: '',
					ship_name: '',
				}
			}
		},
		methods: {
			getbreedplanDl(id) {
				getbreedplanDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.breedplanDl = res.data;
						getPetGiftDl({
							id: res.data.gift_bag_info._id
						}).then(response => {
							console.log('商品信息',response)
							if (response.code == 0) {
								let card = response.data.gift_bag_plan_items.card.map(item => {
									return {
										...item,
										...{
											goods_type: 0
										}
									}
								})
								let goods = response.data.gift_bag_plan_items.goods.map(item => {
									return {
										...item,
										...{
											goods_type: 6
										}
									}
								})
								this.currentGoods = [...card, ...goods];

							}
						})
					}
				})
			},
			refresh() {
				this.getbreedplanDl(this.$route.query.id)
			},
			toogleExpand(row) {
				let $table = this.$refs['table'];
				$table.toggleRowExpansion(row);
			},
			handleClose(custom) {
				let index;
				this.breedplanDl.next_plan.goods_list.forEach(item => {
					index = item.order_item_goods_list.findIndex(ele => {
						return ele.custom_code == custom;
					})
					item.order_item_goods_list.splice(index, 1);
				})
			},

			search() {
				let params = {
					goodsCustomCode: this.customcode,
				};
				let isRepeat;
				//判断是否重复
				getGoodsCustomCodeInfo(params).then((res) => {
					if (res.code == 0) {
						this.breedplanDl.next_plan.goods_list.forEach(item => {
							if (item.goods_id == res.data.goodsId) {
								isRepeat = item.order_item_goods_list.some(ele => {
									return ele.custom_code == res.data.customCode;
								})
							}

						})
						if (isRepeat) {
							this.$message.error('条码重复');
							this.goodsCustomCode = "";
						} else {
							this.breedplanDl.next_plan.goods_list.forEach(item => {
								if (item.goods_id == res.data.goodsId) {
									item.order_item_goods_list.push({
										cost_price: res.data.costPrice,
										custom_code: res.data.customCode,
										goods_id: res.data.goodsId,
										goods_name: res.data.goodsName,
										goods_type: 0,
										model: res.data.skuValue,
										out_unit: res.data.skuValue,
										skus: res.data.skus,
										unit: res.data.unit,
										unit_id: res.data.unitId,
										validity_stop_date: res.data.validityStopDate,
										firstcode: true,
									})
									this.plancodeParams.codes.push(res.data.customCode)
								} else {
									this.$message.error('此条码的商品与计划商品不一致，请检查条码商品信息');
								}

							})
						}
					}
				})
			},
			addcodes() {
				if (this.plancodeParams.codes.length == 0) {
					this.$message.error('请录入条码');
				} else {
					this.plancodeParams.id = this.breedplanDl._id;
					this.plancodeParams.plan_no = this.breedplanDl.next_plan.plan_no;
					addPlanGoodsCodes(this.plancodeParams).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '恭喜你，这是一条成功消息',
								type: 'success'
							});
							this.$router.go(-1)
						}
					})
				}
			},
			setship() {
				this.dialogVisible = true;
				this.shipParams.id = this.breedplanDl._id;
				this.shipParams.plan_no = this.breedplanDl.next_plan.plan_no;
				this.shipParams.ship_no = this.breedplanDl.next_plan.ship_no == null ? '' : this.breedplanDl.next_plan
					.ship_no;
				this.shipParams.ship_name = this.breedplanDl.next_plan.ship_name == null ? '' : this.breedplanDl.next_plan
					.ship_name;

			},
			submitShip(){
				setPlanShip(this.shipParams).then(res=>{
					if(res.code==0){
						this.$message({
							message: '录入成功',
							type: 'success'
						});
						this.dialogVisible =false;
						this.$router.push({path:'/breedplan/detail',query:{id:this.$route.query.id}})
						// this.getbreedplanDl(this.$route.query.id)
					}
				})
			},
			getAdress(value){
				return JSON.parse(value)
			},
			goback(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.go(-1)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
		},
		
		created() {
			this.getbreedplanDl(this.$route.query.id)
		},
		computed: {
			totalcount() {
				let count = 0;
				this.breedplanDl.next_plan.goods_list.forEach(item => {
					count += item.count
				})
				return count;
			},
			hadcount() {
				let count = 0;
				this.breedplanDl.next_plan.goods_list.forEach(item => {
					count += item.order_item_goods_list.length
				})
				return count;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.con {
			.title {
				display: flex;
				justify-content: space-between;
				border-left: 2px solid #F5882A;
				font-weight: 600;
				padding-left: 5px;
				align-items: center;

				.tittext {
					font-size: 16px;
				}

				.refen {
					color: #F5882A;
				}
			}

			.top {
				display: flex;

				.left {
					width: 50%;
					display: flex;

					.userinfo {
						width: 50%;
						background-color: #fff;
						padding: 10px;
						border-radius: 6px;

						.useritem {
							margin: 8px;

							.usertext {
								display: inline-block;
								width: 18%;
								font-size: 14px;
								color: #2a2a2a;
								text-align: right;
							}

							.userdesc {
								font-size: 12px;
								color: #999
							}
						}
					}

					.planinfo {
						width: 50%;
						background-color: #fff;
						padding: 10px;
						border-radius: 6px;
						margin-left: 10px;

						.useritem {
							.usertext {
								width: 24%;
								// text-align: left;
							}

						}
					}
				}

				.right {
					background-color: #fff;
					width: 50%;
					margin-left: 10px;
					padding: 10px;
				}
			}

			.bottom {
				margin-top: 10px;
				display: flex;

				.lf {
					width: 50%;
					background-color: #fff;
					padding: 10px;
					position: relative;

					.plandl {
						display: flex;
						justify-content: space-between;

						.plantext {
							font-size: 14px;
							color: #2a2a2a;
						}

						.plandesc {
							color: #999;
							font-size: 12px;
						}
					}

					.plancode {
						font-size: 14px;
						margin-top: 10px;
					}

					.chuku {
						// position: absolute;
						// bottom: 0;
						margin-top: 20px;
					}
				}

				.rg {
					width: 50%;
					margin-left: 10px;
					background-color: #fff;
					padding: 10px;
				}
			}
		}
	}
</style>
<style>
	.el-collapse {
		border: none;

	}

	.el-collapse-item__header {
		background-color: #f8f8f8;
		border: none;
		padding: 0 10px;
	}
</style>
